import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ButtonBase from "@mui/material/ButtonBase";
import { DateTime } from "luxon";

const LABEL_SX = { fontSize: "0.55rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.06em", lineHeight: 1, color: "inherit" };

function DatePill({ active, top, main, bottom, count, onClick }) {
  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        flexShrink: 0,
        minWidth: "3.5rem",
        py: 0.75,
        px: 0.75,
        borderRadius: 2,
        border: "1px solid",
        borderColor: active ? "primary.main" : "divider",
        bgcolor: active ? "primary.main" : "#fff",
        color: active ? "#fff" : "text.primary",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        transition: "all 0.15s ease",
        "&:hover": { borderColor: "primary.main" }
      }}
    >
      <Typography sx={LABEL_SX}>{top}</Typography>
      <Typography sx={{ fontSize: "1rem", fontWeight: 700, lineHeight: 1.3, color: "inherit" }}>{main}</Typography>
      <Typography sx={{ ...LABEL_SX, fontSize: "0.5rem", mt: 0.25, opacity: 0.75 }}>{bottom}</Typography>
      {count != null && (
        <Typography sx={{ fontSize: "0.55rem", fontWeight: 600, lineHeight: 1, mt: 0.25, color: active ? "rgba(255,255,255,0.85)" : "primary.main" }}>
          {count}
        </Typography>
      )}
    </ButtonBase>
  );
}

function EventDateStrip({ dates, selectedDate, totalEvents, onSelect }) {
  if (dates.length < 2) return null;

  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.75,
        mb: 3,
        flexWrap: { xs: "nowrap", md: "wrap" },
        overflowX: { xs: "auto", md: "visible" },
        pb: { xs: 0.5, md: 0 },
        "&::-webkit-scrollbar": { display: "none" },
        scrollbarWidth: "none"
      }}
    >
      <DatePill active={!selectedDate} top="All" main={totalEvents} bottom="events" onClick={() => onSelect(null)} />
      {dates.map(({ date, count }) => {
        const dt = DateTime.fromISO(date);
        return (
          <DatePill
            key={date}
            active={selectedDate === date}
            top={dt.toFormat("ccc")}
            main={dt.day}
            bottom={dt.toFormat("LLL")}
            count={count}
            onClick={() => onSelect(date)}
          />
        );
      })}
    </Box>
  );
}

export default EventDateStrip;
